import { toPrecision } from '@curbnturf/helpers';
import { IAmenity, IBoondock, IBoondockPoint } from '../interfaces';
import { Address } from './address';
import { Amenity } from './amenity';
import { Boondock } from './boondock';
import { MapPoint } from './map-point';

export class BoondockPoint extends MapPoint implements IBoondockPoint {
  syncId?: string;
  amenities?: IAmenity[];
  price?: number;
  boondock?: IBoondock;

  public static fromBoondock(boondock: IBoondock | Boondock): BoondockPoint {
    const mapPoint = new this();

    if (boondock.coordinates) {
      mapPoint.coordinates = {
        lat: toPrecision(boondock.coordinates.lat, 2),
        lon: toPrecision(boondock.coordinates.lon, 2),
      };
    }

    if (boondock.id && boondock.name) {
      mapPoint.id = boondock.id;
      mapPoint.name = boondock.name;
    }

    if (boondock.description) {
      mapPoint.description = boondock.description;
    }

    if (boondock.photos) {
      mapPoint.photos = boondock.photos;
    } else {
      mapPoint.photos = [];
    }

    if (boondock.address && boondock.address.city && boondock.address.state) {
      mapPoint.location = `${boondock.address.city}, ${boondock.address.state}`;
    } else if (boondock.address && boondock.address.city) {
      mapPoint.location = `${boondock.address.city}`;
    } else if (boondock.address && boondock.address.state) {
      mapPoint.location = `${boondock.address.state}`;
    } else {
      mapPoint.location = '';
    }

    if (boondock instanceof Boondock) {
      mapPoint.rating = boondock.getRating();
      mapPoint.ratingCount = boondock.getRatingCount();
    }

    mapPoint.boondock = boondock;

    return mapPoint;
  }
  constructor(data?: IBoondockPoint) {
    super(data);

    if (data) {
      this.setData(data);
    }
  }

  setData(data: IBoondockPoint): void {
    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (this as any)[key] = (data as any)[key];
      }
    }

    if (this.address) {
      this.address = new Address(this.address);
    }

    if (data.amenities) {
      this.amenities = data.amenities.map((amenity) => {
        if (typeof amenity === 'string') {
          return new Amenity({ type: amenity });
        }

        return new Amenity(amenity);
      });
    }

    if (this.boondock) {
      this.boondock = new Boondock(this.boondock);
    }
  }

  getName(): string {
    return this.name || 'Unidentified Boondock';
  }
}
